import { Component, OnInit } from '@angular/core';
import { ProjectDataForm } from '../_models/project-data-form';
import { MatTableDataSource } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ProjectService } from '../_services/project.service';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.css']
})
export class ProjectListComponent implements OnInit {

  updateFlag = '';
  userDetailsId: any;
  projectDataFormList: ProjectDataForm[] = [];
  projectDataSource = new MatTableDataSource<ProjectDataForm>();
  displayedColumns = ['projectId', 'projectName',];
  constructor(
    private projectService: ProjectService,
    private activatedRoute: ActivatedRoute,

  ) {
    this.activatedRoute.params.subscribe(params => {
      this.userDetailsId = params['id'];
      this.updateFlag = 'true';
    });
  }

  ngOnInit() {
  }

  applyFilter(filterValue: string) {
    this.projectDataSource.filter = filterValue.trim().toLowerCase();
  }

}
